import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer.jsx";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const EvaluationInitialeWP = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="evaluation-initiale-maitriser-les-bases-de-word-press"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default EvaluationInitialeWP;